import { render, staticRenderFns } from "./FlashError.vue?vue&type=template&id=50a9ed2c&scoped=true"
import script from "./FlashError.vue?vue&type=script&lang=js"
export * from "./FlashError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a9ed2c",
  null
  
)

export default component.exports